export default [
  { label: 'Joystick', width: 'label', group: true },

  { name: 'JS0',  code: 'JS_0',  title: '按键0' },
  { name: 'JS1',  code: 'JS_1',  title: '按键1' },
  { name: 'JS2',  code: 'JS_2',  title: '按键2' },
  { name: 'JS3',  code: 'JS_3',  title: '按键3' },
  { name: 'JS4',  code: 'JS_4',  title: '按键4' },
  { name: 'JS5',  code: 'JS_5',  title: '按键5' },
  { name: 'JS6',  code: 'JS_6',  title: '按键6' },
  { name: 'JS7',  code: 'JS_7',  title: '按键7' },
  { name: 'JS8',  code: 'JS_8',  title: '按键8' },
  { name: 'JS9',  code: 'JS_9',  title: '按键9' },
  { name: 'JS10', code: 'JS_10', title: '按键10' },
  { name: 'JS11', code: 'JS_11', title: '按键11' },
  { name: 'JS12', code: 'JS_12', title: '按键12' },
  { name: 'JS13', code: 'JS_13', title: '按键13' },
  { name: 'JS14', code: 'JS_14', title: '按键14' },
  { name: 'JS15', code: 'JS_15', title: '按键15' },
  { width: 0 },

  { name: 'JS16', code: 'JS_16', title: '按键16' },
  { name: 'JS17', code: 'JS_17', title: '按键17' },
  { name: 'JS18', code: 'JS_18', title: '按键18' },
  { name: 'JS19', code: 'JS_19', title: '按键19' },
  { name: 'JS20', code: 'JS_20', title: '按键20' },
  { name: 'JS21', code: 'JS_21', title: '按键21' },
  { name: 'JS22', code: 'JS_22', title: '按键22' },
  { name: 'JS23', code: 'JS_23', title: '按键23' },
  { name: 'JS24', code: 'JS_24', title: '按键24' },
  { name: 'JS25', code: 'JS_25', title: '按键25' },
  { name: 'JS26', code: 'JS_26', title: '按键26' },
  { name: 'JS27', code: 'JS_27', title: '按键27' },
  { name: 'JS28', code: 'JS_28', title: '按键28' },
  { name: 'JS29', code: 'JS_29', title: '按键29' },
  { name: 'JS30', code: 'JS_30', title: '按键30' },
  { name: 'JS31', code: 'JS_31', title: '按键31' },
  { width: 0 },

  { name: '轴0减小', code: 'JS_AXIS0_CCW', title: '轴0减小' },
  { name: '轴0增大', code: 'JS_AXIS0_CW',  title: '轴0增大' },
  { width: 500 },
  { name: '轴1减小', code: 'JS_AXIS1_CCW', title: '轴1减小' },
  { name: '轴1增大', code: 'JS_AXIS1_CW',  title: '轴1增大' },
  { width: 500 },
  { name: '轴2减小', code: 'JS_AXIS2_CCW', title: '轴2减小' },
  { name: '轴2增大', code: 'JS_AXIS2_CW',  title: '轴2增大' },
  { width: 500 },
  { name: '轴3减小', code: 'JS_AXIS3_CCW', title: '轴3减小' },
  { name: '轴3增大', code: 'JS_AXIS3_CW',  title: '轴3增大' },
  { width: 500 },
  { name: '轴0回中', code: 'JS_AXIS0_CNT', title: '轴0回中' },
  { name: '轴1回中', code: 'JS_AXIS1_CNT', title: '轴1回中' },
  { name: '轴2回中', code: 'JS_AXIS2_CNT', title: '轴2回中' },
  { name: '轴3回中', code: 'JS_AXIS3_CNT', title: '轴3回中' },
  { width: 0 },
  
  { name: '响应曲线1', code: 'JS_PROF0', title: '线性，移动速度最慢' },
  { name: '响应曲线2', code: 'JS_PROF1', title: '线性，移动速度中等' },
  { name: '响应曲线3', code: 'JS_PROF2', title: '线性，移动速度最快' },
  { name: '响应曲线4', code: 'JS_PROF3', title: '非线性，移动速度最慢' },
  { name: '响应曲线5', code: 'JS_PROF4', title: '非线性，移动速度中等' },
  { name: '响应曲线6', code: 'JS_PROF5', title: '非线性，移动速度最快' }

];
